import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button, UncontrolledTooltip } from "reactstrap";
import { translationHookOptions } from "../../app/localization/localization";
import { ISurveyPermissions } from "../../app/models/dto";
import { RootStoreContext } from "../../app/stores/rootStore";

interface IParams {
  surveyId: number;
  permissions: ISurveyPermissions;
}

const SurveyShareButton: React.FC<IParams> = ({ surveyId, permissions }) => {
  const rootStore = useContext(RootStoreContext);
  const { view } = rootStore.surveyStore;
  const { attendingMeeting } = rootStore.playerStore;
  const { showSurveyToAttendees, showSurveyResultsToAttendees } =
    rootStore.tenantStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["surveys"], translationHookOptions);

  const handleShareBtnClick = () => {
    if (view === "vote") showSurveyToAttendees(surveyId);
    else if (view === "result") showSurveyResultsToAttendees(surveyId);
  };
  return (
    <>
      {attendingMeeting && permissions && permissions.canShareSurvey ? (
        <>
          <Button
            className={classnames(
              `${theme!.buttonBorderColor}`,
              view === "vote"
                ? "surveyButtonVote bg-white"
                : `surveyButton w-100 ${theme!.buttonColor}`
            )}
            // color="white"
            onClick={handleShareBtnClick}
            id="condividi"
          >
            {view === "vote"
              ? t("answer_toolbar_share_survey")
              : t("answer_toolbar_share_results")}
          </Button>
          <UncontrolledTooltip delay={0} placement="top" target="condividi">
            {view === "vote"
              ? t("answer_toolbar_share_survey")
              : t("answer_toolbar_share_results")}
          </UncontrolledTooltip>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(SurveyShareButton);
